/** Sample PrintHQ Vault data for demo mode (no Supabase configured). */
import type { VaultModel, VaultModelMeta, VaultObject } from '@/stores/vault'

const day = 86_400_000
const at = (daysAgo: number) => new Date(Date.now() - daysAgo * day).toISOString()

/** A small isometric block in the model's color, as an SVG data URI. */
function block(color: string, shade: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><ellipse cx="128" cy="200" rx="74" ry="16" fill="#0f172a" opacity=".08"/><path d="M128 52 204 94v78l-76 42-76-42V94z" fill="${color}"/><path d="M128 136v78l-76-42V94z" fill="${shade}" opacity=".85"/><path d="M128 52 204 94l-76 42-76-42z" fill="#fff" opacity=".22"/></svg>`
  return 'data:image/svg+xml;base64,' + btoa(svg)
}

const models: [string, string, string | null, string[], [string, number, string][], string, string][] = [
  ['vm-1', 'Flexi Dragon', 'Miniatures/Dragons', ['flexi', 'toys'], [['flexi-dragon.3mf', 4_800_000, '3mf'], ['flexi-dragon.stl', 12_400_000, 'stl']], '#22c55e', '#15803d'],
  ['vm-2', 'Articulated Axolotl', 'Miniatures', ['flexi'], [['axolotl.3mf', 8_900_000, '3mf']], '#f472b6', '#be185d'],
  ['vm-3', 'Cable Clip', 'Functional', ['desk'], [['cable-clip.stl', 210_000, 'stl'], ['cable-clip_PLA_0.2mm.gcode', 1_300_000, 'gcode']], '#38bdf8', '#0369a1'],
  ['vm-4', 'Filament Spool Holder', 'Functional', ['workshop'], [['spool-holder.3mf', 2_100_000, '3mf'], ['assembly.png', 640_000, 'png']], '#f59e0b', '#b45309'],
  ['vm-5', 'Snowblob Ornament', 'Gifts', ['christmas', 'gift'], [['snowblob.3mf', 37_800_000, '3mf']], '#e2e8f0', '#94a3b8'],
  ['vm-6', 'Benchy', null, ['calibration'], [['benchy.3mf', 3_200_000, '3mf']], '#ef4444', '#b91c1c'],
]

export const demoVaultModels: VaultModel[] = models.map(([id, name, folder, tags], i) => ({
  id,
  name,
  folder_path: folder,
  tags,
  primary_object_id: `${id}-0`,
  preview_object_id: `${id}-0`,
  description: null,
  source_url: null,
  creator: null,
  license: null,
  created_at: at(40 - i * 5),
  updated_at: at(10 - i),
}))

export const demoVaultObjects: VaultObject[] = models.flatMap(([id, , , , files], i) =>
  files.map(([file_name, size_bytes, ext], k) => ({
    id: `${id}-${k}`,
    model_id: id,
    file_name,
    file_ext: ext,
    size_bytes,
    current_version: 1 + ((i + k) % 3),
    created_at: at(40 - i * 5),
    updated_at: at(10 - i - k),
  })),
)

export const demoVaultMeta: Record<string, VaultModelMeta> = Object.fromEntries(
  models.map(([id, , , , , color, shade], i) => [
    id,
    {
      thumb: block(color, shade),
      dims: [40 + i * 12, 30 + i * 5, 20 + i * 8],
      color_count: i % 2 ? 1 : 3,
      is_multicolor: i % 2 === 0,
      printer_model: 'Bambu Lab X1 Carbon',
      slicer: 'BambuStudio',
    } satisfies VaultModelMeta,
  ]),
)
